<div class="debug-container"
    style="background-color: #f9f9f9; padding: 1em; border: 1px solid #ccc; height: 625px; overflow-y: auto;">
    <h3>{{ label }}</h3>
    <pre>{{ data | json }}</pre>

    <div *ngIf="comp">
        <h4>Compare obj1 & obj2</h4>
        <pre>{{ diff | json }}</pre>
    </div>
</div>